<div *ngIf='valueController' [formGroup]='valueController' fxLayout="column">
  <mat-form-field appearance='outline'>
    <mat-label class='text-muted'>{{ label }}</mat-label>
    <textarea
      formControlName="textValue"
      matInput
      cdkTextareaAutosize
      [cdkAutosizeMaxRows]="4"
      [cdkAutosizeMinRows]="1"
    ></textarea>

    <span class="hint-msg">{{ hint }}</span>
  </mat-form-field>
</div>
